import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "id", "size", "mode", "title", "description", "action", "actions", "children", "columns", "emptyText"],
    _excluded2 = ["className", "children", "onEdit", "actions", "isNested", "emptyAction", "emptyActions", "metadata", "label"],
    _excluded3 = ["className", "children", "tooltip", "onEdit", "actions"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { forwardRef, createContext, useContext } from 'react';
import { ThemeProvider } from 'styled-components';
import cx from 'classnames';
import { prefix } from '../../tools/settings';
import { Styled } from './Groups.styles';
import IconButton from '../IconButton';
import Tooltip from '../Tooltip';
import Button from '../Button';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var GroupsContext = createContext();
var Groups = forwardRef(function (_ref, ref) {
  var _cx;

  var customClassName = _ref.className,
      id = _ref.id,
      size = _ref.size,
      mode = _ref.mode,
      title = _ref.title,
      description = _ref.description,
      action = _ref.action,
      actions = _ref.actions,
      children = _ref.children,
      _ref$columns = _ref.columns,
      columns = _ref$columns === void 0 ? 'auto' : _ref$columns,
      _ref$emptyText = _ref.emptyText,
      emptyText = _ref$emptyText === void 0 ? "You don't have any content in this group yet." : _ref$emptyText,
      rest = _objectWithoutProperties(_ref, _excluded);

  var context = {
    columns: columns,
    emptyText: emptyText
  };
  var className = cx((_cx = {}, _defineProperty(_cx, "".concat(prefix, "-groups"), true), _defineProperty(_cx, customClassName, !!customClassName), _cx));
  return _jsx(ThemeProvider, {
    theme: {
      mode: mode,
      size: size
    },
    children: _jsxs(GroupsContext.Provider, {
      value: context,
      children: [_jsxs(Styled.GroupsHeader, {
        children: [description && _jsx(Styled.GroupsDescription, {
          children: description
        }), (actions || action) && _jsxs(Styled.GroupsHeaderActions, {
          children: [action && _jsx(Styled.GroupsLink, {
            iconLeft: action.icon,
            onClick: action.onClick,
            isDisabled: action.isDisabled,
            url: action.url,
            children: action.label
          }), actions]
        })]
      }), _jsx(Styled.Groups, _objectSpread(_objectSpread({
        ref: ref,
        className: className
      }, rest), {}, {
        children: children
      }))]
    })
  });
});
var Group = forwardRef(function (_ref2, ref) {
  var _cx2;

  var customClassName = _ref2.className,
      children = _ref2.children,
      onEdit = _ref2.onEdit,
      actions = _ref2.actions,
      _ref2$isNested = _ref2.isNested,
      isNested = _ref2$isNested === void 0 ? false : _ref2$isNested,
      emptyAction = _ref2.emptyAction,
      emptyActions = _ref2.emptyActions,
      metadata = _ref2.metadata,
      label = _ref2.label,
      rest = _objectWithoutProperties(_ref2, _excluded2);

  var _useContext = useContext(GroupsContext),
      columns = _useContext.columns,
      emptyText = _useContext.emptyText;

  var className = cx((_cx2 = {}, _defineProperty(_cx2, "".concat(prefix, "-groups__group"), true), _defineProperty(_cx2, "".concat(prefix, "-groups__group--nested"), isNested), _defineProperty(_cx2, customClassName, !!customClassName), _cx2));
  return _jsxs(Styled.GroupSection, {
    children: [metadata && _jsx(Styled.GroupMetadata, {
      children: metadata
    }), label && _jsxs(Styled.GroupLabel, {
      children: [label, ' ', onEdit && _jsx(IconButton, {
        icon: "edit",
        onClick: onEdit,
        variant: "ghost",
        size: "small"
      })]
    }), actions && _jsx(Styled.GroupActions, {
      children: actions
    }), children ? _jsx(Styled.Group, _objectSpread(_objectSpread({
      ref: ref,
      className: className,
      columns: columns,
      isNested: isNested
    }, rest), {}, {
      children: children
    })) : _jsxs(Styled.GroupEmpty, {
      children: [emptyText, ' ', emptyAction && _jsx(Button, {
        variant: "ghost",
        size: "small",
        style: {
          marginLeft: 4
        },
        iconLeft: emptyAction.icon,
        isLoading: emptyAction.isLoading,
        isDisabled: emptyAction.isDisabled,
        onClick: emptyAction.onClick,
        children: emptyAction.label
      }), emptyActions && emptyActions.map(function (action, index) {
        return _jsx(Button, {
          variant: "ghost",
          size: "small",
          style: {
            marginLeft: 4
          },
          iconLeft: action.icon,
          isLoading: action.isLoading,
          isDisabled: action.isDisabled,
          onClick: action.onClick,
          children: action.label
        }, index);
      })]
    })]
  });
});
var GroupItem = forwardRef(function (_ref3, ref) {
  var _cx3;

  var customClassName = _ref3.className,
      children = _ref3.children,
      tooltip = _ref3.tooltip,
      onEdit = _ref3.onEdit,
      actions = _ref3.actions,
      rest = _objectWithoutProperties(_ref3, _excluded3);

  var className = cx((_cx3 = {}, _defineProperty(_cx3, "".concat(prefix, "-groups__group--item"), true), _defineProperty(_cx3, customClassName, !!customClassName), _cx3));
  return _jsxs(Styled.GroupItem, _objectSpread(_objectSpread({
    ref: ref,
    className: className
  }, rest), {}, {
    children: [_jsxs(Styled.GroupText, {
      children: [children, ' ', tooltip && _jsx(Tooltip, {
        size: "medium",
        content: tooltip,
        children: _jsx(Styled.GroupInfoIcon, {})
      })]
    }), _jsxs(Styled.GroupControls, {
      children: [onEdit && _jsx(IconButton, {
        icon: "edit",
        onClick: onEdit,
        variant: "ghost",
        size: "small"
      }), actions]
    })]
  }));
});
Groups.displayName = 'Groups';
Groups.Group = Group;
Groups.Item = GroupItem;
export default Groups;